(function(){
  const FAV_KEY='nestora:favorites:v1';
  const readFavs=()=>{try{return JSON.parse(localStorage.getItem(FAV_KEY)||'[]')}catch(e){return[]}};
  const writeFavs=(items)=>{localStorage.setItem(FAV_KEY,JSON.stringify(items));syncFavUI(items)};
  const normalize=(el)=>({key:el.dataset.favoriteKey||el.dataset.productHandle||el.dataset.productUrl||'',title:el.dataset.productTitle||'NESTORA favorite',price:el.dataset.productPrice||'',image:el.dataset.productImage||'',url:el.dataset.productUrl||'/collections/all'});
  const isFav=(items,key)=>items.some(x=>x.key===key);
  function syncFavUI(items){
    document.querySelectorAll('[data-favorite-toggle]').forEach(btn=>{const key=btn.dataset.favoriteKey||btn.dataset.productHandle||btn.dataset.productUrl||'';const active=isFav(items,key);btn.classList.toggle('is-favorite',active);btn.setAttribute('aria-pressed',active?'true':'false');btn.setAttribute('aria-label',active?'Remove from favorites':'Add to favorites');btn.querySelector('[data-heart]')?.replaceChildren(document.createTextNode(active?'♥':'♡'));});
    document.querySelectorAll('[data-favorite-count]').forEach(el=>el.textContent=items.length);
    const list=document.querySelector('[data-favorites-list]');
    const empty=document.querySelector('[data-favorites-empty]');
    if(list){list.innerHTML='';items.forEach(item=>{const row=document.createElement('article');row.className='favorite-row';row.innerHTML=`<a class="favorite-thumb" href="${item.url}">${item.image?`<img src="${item.image}" alt="">`:'<span>N</span>'}</a><div><a class="favorite-title" href="${item.url}">${item.title}</a>${item.price?`<small>${item.price}</small>`:''}</div><button type="button" class="favorite-remove" data-remove-favorite="${item.key}" aria-label="Remove ${item.title}">×</button>`;list.appendChild(row)});}
    if(empty) empty.hidden=items.length>0;
  }
  function openFavs(){document.querySelector('[data-favorites-drawer]')?.classList.add('open');document.querySelector('[data-favorites-backdrop]')?.classList.add('open');document.body.classList.add('drawer-open')}
  function closeFavs(){document.querySelector('[data-favorites-drawer]')?.classList.remove('open');document.querySelector('[data-favorites-backdrop]')?.classList.remove('open');document.body.classList.remove('drawer-open')}
  document.addEventListener('DOMContentLoaded',()=>{
    const drawer=document.querySelector('[data-mobile-menu]');
    document.querySelectorAll('[data-menu-toggle]').forEach(b=>b.addEventListener('click',()=>drawer&&drawer.classList.toggle('open')));
    document.querySelectorAll('.mobile-drawer a').forEach(a=>a.addEventListener('click',()=>drawer&&drawer.classList.remove('open')));
    syncFavUI(readFavs());
    document.addEventListener('click',(e)=>{
      const favBtn=e.target.closest('[data-favorite-toggle]');
      if(favBtn){e.preventDefault();e.stopPropagation();let items=readFavs();const item=normalize(favBtn);items=isFav(items,item.key)?items.filter(x=>x.key!==item.key):[item,...items.filter(x=>x.key!==item.key)];writeFavs(items);return;}
      const remove=e.target.closest('[data-remove-favorite]');
      if(remove){writeFavs(readFavs().filter(x=>x.key!==remove.dataset.removeFavorite));return;}
      if(e.target.closest('[data-favorites-open]')){e.preventDefault();openFavs();return;}
      if(e.target.closest('[data-favorites-close]')||e.target.matches('[data-favorites-backdrop]')){e.preventDefault();closeFavs();return;}
    });
    document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeFavs();drawer?.classList.remove('open')}});
  });
})();

/* NESTORA PRO product gallery + Shopify-native variant UX v16 */
(function(){
  function money(cents,currency){
    var amount=Number(cents||0)/100;
    try{
      if(currency==='EUR') return new Intl.NumberFormat(document.documentElement.lang||'en',{minimumFractionDigits:2,maximumFractionDigits:2}).format(amount)+' €';
      return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currency||'EUR'}).format(amount);
    }catch(e){return amount.toFixed(2)+(currency==='EUR'?' €':' '+currency)}
  }
  function initProduct(root){
    if(!root || root.dataset.nestoraVariantReady==='1') return;
    root.dataset.nestoraVariantReady='1';
    var mainImage=root.querySelector('#ProductMainImage,.npdp-main-image');
    var jsonEl=root.querySelector('[data-product-json]');
    var mediaEl=root.querySelector('[data-variant-media-json]');
    var select=root.querySelector('[data-variant-select]');
    if(!jsonEl||!select) return;
    var variants=[],mediaMap={};
    try{variants=JSON.parse(jsonEl.textContent||'[]')}catch(e){console.error('Nestora variants JSON',e)}
    try{mediaMap=JSON.parse((mediaEl&&mediaEl.textContent)||'{}')}catch(e){console.error('Nestora media JSON',e)}
    var currency=root.dataset.currency||(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';

    function setImage(src,alt,mediaId){
      if(!mainImage||!src)return;
      mainImage.src=src;
      mainImage.removeAttribute('srcset');
      if(alt!=null)mainImage.alt=alt;
      root.querySelectorAll('[data-gallery-thumb]').forEach(function(t){t.classList.toggle('is-active',String(t.dataset.mediaId)===String(mediaId||''))});
    }
    function currentOptions(){
      var out=[];
      root.querySelectorAll('fieldset[data-option-index]').forEach(function(g){
        var idx=Number(g.dataset.optionIndex),active=g.querySelector('[data-option-value].is-selected');
        if(active)out[idx]=active.dataset.optionValue;
      });
      return out;
    }
    function resolveVariant(){
      var opts=currentOptions();
      return variants.find(function(v){return v.options.every(function(val,i){return opts[i]==null||String(val)===String(opts[i])})})||null;
    }
    function applyVariant(v,preferredButton){
      if(!v)return;
      select.value=String(v.id);
      select.dispatchEvent(new Event('change',{bubbles:true}));
      var price=root.querySelector('[data-current-price]'),compare=root.querySelector('[data-compare-price]'),pill=root.querySelector('[data-sale-pill]');
      if(price)price.textContent=money(v.price,currency);
      if(compare){var sale=v.compare_at_price&&v.compare_at_price>v.price;compare.hidden=!sale;compare.textContent=sale?money(v.compare_at_price,currency):''}
      if(pill){var sale2=v.compare_at_price&&v.compare_at_price>v.price;pill.hidden=!sale2;pill.textContent=sale2?'SAVE '+money(v.compare_at_price-v.price,currency):''}
      var add=root.querySelector('[data-add-to-cart]'),label=root.querySelector('[data-add-label]');
      if(add)add.disabled=!v.available;
      if(label)label.textContent=v.available?'ADD TO BAG':'SOLD OUT';
      var stock=root.querySelector('[data-stock-status]');
      if(stock){stock.classList.toggle('is-out',!v.available);var sp=stock.querySelector('span');if(sp)sp.textContent=v.available?'In stock · ready to order':'Currently unavailable'}
      var media=mediaMap[String(v.id)];
      if(media&&media.src)setImage(media.src,media.alt||'',media.media_id);
      else if(preferredButton&&preferredButton.dataset.colorImageSrc)setImage(preferredButton.dataset.colorImageSrc,preferredButton.dataset.colorImageAlt||'',preferredButton.dataset.colorMediaId||'');
      if(history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u.toString())}
      root.dispatchEvent(new CustomEvent('nestora:variant-change',{detail:{variant:v},bubbles:true}));
    }

    root.addEventListener('click',function(e){
      var thumb=e.target.closest('[data-gallery-thumb]');
      if(thumb){e.preventDefault();setImage(thumb.dataset.imageSrc,thumb.dataset.imageAlt||'',thumb.dataset.mediaId);return}
      var btn=e.target.closest('[data-option-value]');
      if(btn){
        e.preventDefault();
        var group=btn.closest('fieldset[data-option-index]');
        if(!group)return;
        group.querySelectorAll('[data-option-value]').forEach(function(b){b.classList.remove('is-selected');b.setAttribute('aria-pressed','false')});
        btn.classList.add('is-selected');btn.setAttribute('aria-pressed','true');
        // Immediate visual feedback for color, then exact combination variant resolution.
        if(btn.dataset.colorImageSrc)setImage(btn.dataset.colorImageSrc,btn.dataset.colorImageAlt||'',btn.dataset.colorMediaId||'');
        var v=resolveVariant();
        if(!v && btn.dataset.firstVariantId)v=variants.find(function(x){return String(x.id)===String(btn.dataset.firstVariantId)});
        applyVariant(v,btn);return;
      }
      var minus=e.target.closest('[data-qty-minus]'),plus=e.target.closest('[data-qty-plus]');
      if(minus||plus){var q=(minus||plus).closest('[data-qty]'),inp=q&&q.querySelector('input');if(inp){inp.value=Math.max(1,Number(inp.value||1)+(plus?1:-1))}}
    });

    // Initialize image/price with selected Shopify variant.
    var initial=variants.find(function(v){return String(v.id)===String(select.value)});
    if(initial)applyVariant(initial,null);
  }
  function boot(scope){(scope||document).querySelectorAll('[data-product-root]').forEach(initProduct)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document)});else boot(document);
  document.addEventListener('shopify:section:load',function(e){boot(e.target)});
})();
